<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Cookies from 'js-cookie'
export default {
  name: "App",
  data() {
    return {
      timer: false,
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      const token = Cookies.get('token');
      if ((!token || token === 'undefined') && this.$route.login !== 'login') {
        this.$router.push('/login');
      }
    }, 10000);
  },
  methods: {
    ...mapActions(["getUserInfo"])
  },
  computed: mapGetters({
    user: "agent"
  })
};
</script>

<style lang="less">
// @font-face {
//   font-family: "iconfont";
//   /* project id 1098602 */
//   src: url("//at.alicdn.com/t/font_1098602_p2yhejcj86.ttf?t=1653380891809") format("truetype");
// }
@font-face {
  font-family: 'iconfont';  /* Project id 1098602 */
  src: url('//at.alicdn.com/t/font_1098602_9bkt4n5lp6e.woff2?t=1653380891809') format('woff2'),
       url('//at.alicdn.com/t/font_1098602_9bkt4n5lp6e.woff?t=1653380891809') format('woff'),
       url('//at.alicdn.com/t/font_1098602_9bkt4n5lp6e.ttf?t=1653380891809') format('truetype');
}

.iconfonts {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

#app {
  .size;
}

.content-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 5px;
  margin-bottom: 8px;
  line-height: 38px;

  .left {
    display: flex;
    align-items: center;
    margin: 0 0 9px 0;

    .title {
      font-size: 24px;
      color: black;
      font-weight: bold;
    }

    .describe {
      font-size: 12px;
      color: #aaa;
      margin-left: 20px;
      height: 25px;
    }
  }

  .right {
    display: flex;
    align-items: center;
    margin: 0 0 9px 0;
    .btn{
      color:#2d8cf0;
      font-size:15px;
      font-weight:bold;
      cursor: pointer;
    }
  }
}

.tags {
  margin-bottom: 8px;
}

.t-left {
  text-align: left;
}

.t-right {
  text-align: right;
}

.t-center {
  text-align: center;
}

.senior-search {
  color: #2d8cf0;
  cursor: pointer;
  width: 50px;
  text-align: center;
  margin: 0 15px;
}

// 隐藏百度logo
.anchorBL {
  display: none;
}

.ivu-modal-header-inner,
.ivu-form-item-label {
  color: #000 !important;
}

.ivu-select-selected-value {
  color: #000000 !important;
}

.ivu-input,
.ivu-input-group-prepend,
.ivu-input-group-append {
  color: #000000 !important;
}

.ivu-checkbox-wrapper {
  color: #000000 !important;
}


.spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

//登录页面轮播组件样式重写
.ivu-carousel {
  width: 100%;
  height: 100%;
}

.outher-box .ivu-checkbox-wrapper {
  color: #A0ACC2 !important;
  font-size: 14px !important;
}

.tips {
  background: #EAF7FD;
  border-radius: 4px;
  padding: 8px 6px;
  color: #4a5163;
  font-size: 12px;
  display: flex;
}
.filter-box{
  margin-bottom: 20px;
  .bottom{
    margin-top: 20px;
    .btn-filter{
      background:#4788F7;
      padding: 9px 16px;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
    }
    .btn{
      background:white;
      border:1px solid #dedede;
      padding: 9px 16px;
      margin-left: 10px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .subtitle{
    font-size: 14px;
    color: black;
    margin-right: 10px;
  }
  .select{
    width: 270px;
  }
  .item_box{
    margin-top: 10px;
    display:flex;
    align-items: center;
  }
}
</style>
